import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import FindStudentForm from "./findStudentForm";
import { Button, Col, Form, Row } from "react-bootstrap";
import { PsLabel, courseName } from "../../utils";
import { CapsuleTabs, Card } from "antd-mobile";
import NewPayment from "./newPayment";
import PaymentHistory from "./paymentHistory";

const OpenPaymentRegistration = (props) => {
  const context = useContext(PsContext);
  const [activeKey, setActiveKey] = useState("new_payment");

  const getStudent = () => {
    let d = context.getStorage("open_form_student");
    if (d && d != "undefined") return JSON.parse(d);
    else return [];
  };

  const [student, setStudent] = useState(getStudent());

  const onformSuccess = (d) => {
    context.setStorage("open_form_student", JSON.stringify(d));
    setStudent(d);
  };

  const studentField = (fieldName) => student?.[fieldName] || "";

  const logoutClick = () => {
    context.setStorage("open_form_student", "");
    setStudent([]);
  };

  const rightActionLink = () => {
    if (student && student.uuid) {
      return (
        <Button variant="transparent" size="sm" onClick={(e) => logoutClick()}>
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
        </Button>
      );
    }
    return [];
  };

  return (
    <>
      <Header
        title="Online Payment"
        backAction={[]}
        rightActions={rightActionLink()}
      />
      <div className="py-4 mt-4"></div>
      <div className="container">
        {!student.uuid && (
          <FindStudentForm onSuccess={(d) => onformSuccess(d)} />
        )}
        {student && student.uuid && (
          <>
            <Row>
              <Col md={12}>
                <PsLabel text="Student Name" />
                <Form.Control
                  type="text"
                  value={studentField("student_name")}
                  className="fw-bold"
                  size="sm"
                  readOnly
                />
              </Col>
            </Row>
            <Row className="">
              <Col className="mt-2">
                <PsLabel text="Register Number" />
                <Form.Control
                  type="text"
                  value={studentField("registerno")}
                  className="fw-bold"
                  size="sm"
                  readOnly
                />
              </Col>
              <Col className="mt-2">
                <PsLabel text="Batch" />
                <Form.Control
                  type="text"
                  value={studentField("batch")}
                  className="fw-bold"
                  size="sm"
                  readOnly
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <PsLabel text="Course" />
                <Form.Control
                  type="text"
                  value={courseName(student)}
                  className="fw-bold"
                  size="sm"
                  readOnly
                />
              </Col>
            </Row>
            <Card>
              <CapsuleTabs
                activeKey={activeKey}
                onChange={(k) => setActiveKey(k)}
              >
                <CapsuleTabs.Tab title="New Payment" key="new_payment">
                  <NewPayment student={student} />
                </CapsuleTabs.Tab>
                <CapsuleTabs.Tab title="Payment History" key="payment_history">
                  <PaymentHistory student={student} />
                </CapsuleTabs.Tab>
              </CapsuleTabs>
            </Card>
          </>
        )}
      </div>
    </>
  );
};
export default OpenPaymentRegistration;
